import { createSlice } from '@reduxjs/toolkit';
import type { CopilotState } from './interfaces';
import { sharedActions } from './shared-actions';

const initialState: CopilotState = {
  startItems: [],
};

export const copilotSlice = createSlice({
  name: 'copilot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sharedActions.appStateLoaded, (state, action) => {
      return action.payload.copilot;
    });
    builder.addCase(sharedActions.userLoggedOutAction, () => {
      return initialState;
    });
  },
});

export default copilotSlice.reducer;
